import { useLocation } from 'react-router-dom';

export function useNonAmpUrl() {
  const location = useLocation();
  return location.pathname.replace('/amp/', '/').replace(/#.+$/, '');
}
